import { render, staticRenderFns } from "./LogWaPremium.vue?vue&type=template&id=111d8169&"
import script from "./LogWaPremium.vue?vue&type=script&lang=js&"
export * from "./LogWaPremium.vue?vue&type=script&lang=js&"
import style0 from "./LogWaPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports